import { IndustryTemplate } from '@/components';
import { pressureWashingContent } from '@/data/industries/pressure-washing';

export function PressureWashingPage() {
  return <IndustryTemplate content={pressureWashingContent} />;
}
